import type {ButtonProps} from '@primer/react'
import type {RefObject} from 'react'
import {createContext} from 'react'

import type {FormattingTools} from './FormattingTools'

// For performance, the properties in context MUST NOT be values that change often - every time
// any of the properties change, all components including memoized ones will be re-rendered
type MarkdownEditorContextProps = {
  disabled: boolean
  required: boolean
  uploadButtonProps: Partial<ButtonProps> | null
  fileUploadProgress?: [number, number]
  fileDraggedOver: boolean
  errorMessage?: React.ReactNode
  previewMode: boolean
}

export const MarkdownEditorContext = createContext<MarkdownEditorContextProps>({
  disabled: false,
  required: false,
  uploadButtonProps: null,
  fileDraggedOver: false,
  previewMode: false,
})

// The formatting tools handle is exposed via its own context, separate from the (volatile)
// editor-state context above. Its value is a ref whose identity is stable for the lifetime of the
// editor, so toolbar buttons that only need the formatting actions never re-render when editor
// state (disabled, drag state, upload progress, ...) changes.
export const FormattingToolsContext = createContext<RefObject<FormattingTools | null>>({current: null})
